import React from "react";
import "./styles.css";
import Message from "./Message";
// import AutoScroll from "@brianmcallister/react-auto-scroll";
import ScrollableFeed from 'react-scrollable-feed'


const Messages = ({ messages }) => {
    console.log("Messages: " + messages);
    const startMessage = { text: "Greetings! How can I assist?", isBot: true };
    const startMessage2 = { text: "You can ask me how to dispose of different items, advice on being sustainable, and more!", isBot: true }
    return (
        <div className="messagesSection">
            {/* <AutoScroll> */}
            <ScrollableFeed>
                <div className="messagesContainer">
                    <Message message={startMessage} />
                    <Message style={{ margin: 0 }} message={startMessage2} />
                </div>
                {messages.map(message => {
                    console.log(message)
                    return (
                        <div className="messagesContainer">
                            <Message message={message} />
                        </div>
                    );
                })}
            </ScrollableFeed>
            {/* </AutoScroll> */}

        </div>

    );
};

export default Messages;